document.addEventListener('DOMContentLoaded', () => {
    let searchAutocompleteObserver = null;
    let searchResultsPageObserver = null;

    function injectSpressoPricesForSearchanise(observer) {
        observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                if (mutation.addedNodes.length) {
                    const searchaniseResults = document.querySelectorAll('.snize-product:not([data-spresso-injected])');
                    searchaniseResults.forEach(result => {
                        result.setAttribute('data-spresso-injected', 'true');

                        // re-inject spresso prices when variant is changed via dropdown
                        const optionsBox = result.querySelector('.snize-options-box');
                        if (optionsBox) {
                            optionsBox.addEventListener('change', () => {
                                result.removeAttribute('data-spresso-injected');
                            });
                        }

                        // re-inject spresso prices when variant is changed via button click
                        const optionsSelectBox = result.querySelector('.snize-size-select-box');
                        if (optionsSelectBox) {
                            optionsSelectBox.addEventListener('click', () => {
                                result.removeAttribute('data-spresso-injected');
                            });
                        }
                        
                        const isOos = result.classList.contains('snize-product-out-of-stock');
                        const productId = result.attributes.getNamedItem('data-original-product-id')?.value;
                        const variantId = result.attributes.getNamedItem('data-product-variant')?.value;
                        const priceList = result.querySelector('.snize-price-list');
                        const searchanisePrice = priceList.querySelector('.snize-price');
                        const discountedPrice = priceList.querySelector('.snize-discounted-price');
                        if (!priceList) return;
                        
                        // priceList may have multiple children if it's a range of prices OR if it has a discounted price
                        const isRange = priceList.children.length > 1 && !priceList.contains(discountedPrice);

                        // create spresso price element
                        const newPriceElement = document.createElement('span')
                        newPriceElement.setAttribute('data-spresso-item-id', variantId ? variantId : productId);
                        newPriceElement.setAttribute('data-spresso-item-type', variantId ? 'variant-id' : 'product-id');
                        newPriceElement.setAttribute('data-spresso-fallback-id', variantId ? variantId : productId);
                        if (!variantId) newPriceElement.setAttribute('data-spresso-pricing-display', isRange ? 'range' : 'min');
                        if (isOos) {
                            newPriceElement.setAttribute('data-spresso-oos', '');
                        }

                        // replace existing price element with spresso price element
                        if (isRange) {
                            newPriceElement.classList.add('snize-price-list');
                            priceList.replaceWith(newPriceElement);
                        } else {
                            newPriceElement.classList.add('snize-price');
                            searchanisePrice.replaceWith(newPriceElement);
                        }
                    });
                }
            });
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    }

    // inject spresso prices for search autocomplete
    const searchDrawer = document.querySelector('#SearchDrawer');
    if (searchDrawer) {
        const intersectionObserver = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    injectSpressoPricesForSearchanise(searchAutocompleteObserver);
                } else {
                    searchAutocompleteObserver?.disconnect();
                }
            });
        }, {
            threshold: 0.1
        });

        intersectionObserver.observe(searchDrawer);
    }

    // inject spresso prices for search results page
    const searchaniseGrid = document.querySelector('div[class="grid"]');
    if (searchaniseGrid) {
        const searchResultsObserver = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                if (mutation.addedNodes.length) {
                    injectSpressoPricesForSearchanise(searchResultsPageObserver);
                } else {
                    searchResultsPageObserver?.disconnect();
                }
            });
        });

        searchResultsObserver.observe(document.body, {
            childList: true,
            subtree: true
        });
    }
    
});
